<template>
  <div class="home__interact">
    <div class="_box">
      <div class="_col">
        <div>
          <div class="_title">Узнайте о проекте больше</div>
          <div class="_text texts">
            Хотите уточнить детали? Оставьте свои контакты, чтобы менеджер
            ответил на ваши вопросы при личном разговоре
          </div>
        </div>
        <form autocomplete="off" @keydown.enter="sendRequestForm">
          <div class="_frm-inputs" v-if="!formSent">
            <div>
              <input
                type="text"
                name="interact_name"
                maxlength="50"
                placeholder="Ваше имя"
                v-model="fields[0].value"
                autocomplete="off"
                :class="{ '--errors': fields[0].wrong }"
                @change="checkForm()"
                @keyup="checkForm()"
              />
            </div>
            <div>
              <input
                type="tel"
                name="interact_phone"
                maxlength="50"
                placeholder="Телефон"
                v-model="fields[1].value"
                autocomplete="off"
                ref="phone"
                :class="{ '--errors': fields[1].wrong }"
                @change="checkForm()"
                @keyup="checkForm()"
              />
            </div>
          </div>

          <div class="_frm-inputs _frm-inputs--result" v-if="formSent">
            Спасибо!
          </div>

          <div class="_frm-info">
            Нажимая на кнопку «Оставить телефон», вы даете<br />
            <a href="https://a-residence.ru/files/terms.pdf"
              >согласие на обработку пользовательских данных</a
            >
          </div>
          <div
            class="_btn"
            @click="sendRequestForm"
            :class="{ disabled: formSent }"
          >
            Оставить телефон
          </div>
        </form>
      </div>
      <div v-if="!onlyForm" class="_col _col--2">
        <div>
          <div class="_title">Подберите резиденции</div>
          <div class="_text texts">
            Специальные условия на резиденции — 20 % до 31.08.2026
          </div>
        </div>
        <a href="/aparts" class="_btn"> Подобрать резиденцию</a>
        <div class="_facade">
          <img :src="require('@/assets/img/facades/new/5.2.svg')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from "inputmask"

export default {
  name: "InteractForm",
  props: {
    onlyForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        { name: "name", wrong: false, value: "" },
        { name: "phone", wrong: false, value: "" },
      ],
      formName: "",
      formPhone: "",
      frmErrors: false,
      formSent: false,
      btnHovered: false,
    }
  },
  methods: {
    btnHover() {
      this.btnHovered = !this.btnHovered
    },
    checkForm() {
      let frmOk = true
      this.fields.forEach((item) => {
        item.wrong = !item.value
        if (item.wrong) frmOk = false
      })
      return frmOk
    },
    async sendRequestForm() {
      // const elem = document.getElementById("comagic__btn")
      // const comagicName = document.getElementById("comagic__name")
      // const comagicPhone = document.getElementById("comagic__phone")
      // comagicName.setAttribute("value", this.fields[0].value)
      // comagicPhone.setAttribute("value", this.fields[1].value)
      // elem.click()

      // let utmParams = {
      //   utm_source: "",
      //   utm_medium: "",
      //   utm_term: "",
      //   utm_content: "",
      //   utm_campaign: "",
      // }

      let qsParams = {}

      let querystring = window.location.toString().split("?")
      if (querystring.length > 1) {
        let pairs = querystring[1].split("&")
        for (let i in pairs) {
          let keyval = pairs[i].split("=")
          qsParams[keyval[0]] = keyval[1]
        }
      }

      if (this.checkForm() && !this.formSent) {
        const rawResponse = await fetch(
          this.$store.getters.getApiUrl + "new_req",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(
              Object.assign(
                { name: this.fields[0].value, phone: this.fields[1].value },
                qsParams
              )
            ),
          }
        )
        const content = await rawResponse.json()

        if (content.status == 1) {
          this.formSent = true

          let ct_site_id = 79192

          // .. like FORM

          let frmData = new FormData()

          frmData.set("fio", this.fields[0].value)
          frmData.set("phoneNumber", this.fields[1].value)
          frmData.set("subject", "Заявка с сайта")
          frmData.set("requestUrl", window.location.href)
          frmData.set(
            "sessionId",
            window.ct("calltracking_params", "v9jnmjbw").sessionId
          )

          fetch(
            "https://api.calltouch.ru/calls-service/RestAPI/requests/" +
              ct_site_id +
              "/register/",
            {
              method: "POST",
              body: frmData,
            }
          )

          console.log("test")
          window.ctw.createRequest(
            "my_form",
            this.fields[1].value,
            [
              { name: "Name", value: this.fields[0].value },
              // { name: "Last name", value: "Petrov" },
            ],
            function (success, data) {
              console.log(success, data)
              if (success) {
                console.log(
                  "Создана заявка на колбек, идентификатор: " +
                    data.callbackRequestId
                )
              } else {
                switch (data.type) {
                  case "request_throttle_timeout":
                  case "request_throttle_count":
                    console.log(
                      "Достигнут лимит создания заявок, попробуйте позже"
                    )
                    break
                  case "request_phone_blacklisted":
                    console.log("номер телефона находится в черном списке")
                    break
                  case "validation_error":
                    console.log("были переданы некорректные данные")
                    break
                  default:
                    console.log(
                      "Во время выполнения запроса произошла ошибка: " +
                        data.type
                    )
                }
              }
            }
          )
        }
      }
    },
  },
  mounted() {
    // ... используем
    if (this.$refs.phone != undefined) {
      var im = new Inputmask("+7 (999) 999-99-99")
      im.mask(this.$refs.phone)
    }
  },
}
</script>
